import { Box } from 'styled-system/jsx';
import { GetEducationDetailQueryResponseType } from '../../queries/getEducationDetail/getEducationDetailQuery.type';
import AudioMedia from './media-content/AudioMedia';
import ImageMedia from './media-content/ImageMedia';
import VideoMedia from './media-content/VideoMedia';

export default function EducationMedia({
  data,
}: {
  data: GetEducationDetailQueryResponseType;
}) {
  const title = data.title ?? 'education-cover';
  const cover = data.image_cover ?? '';

  const isVideo = data.type === 'video' && data.video;
  const isAudio = data.type === 'audio' && data.audio;
  const isImage = !isVideo && !isAudio;

  return (
    <Box
      height={isImage ? '246px' : '270px'}
      width="100%"
      overflow="hidden"
      position="relative"
    >
      {isVideo ? (
        <VideoMedia src={data.video ?? ''} cover={cover} title={title} />
      ) : isAudio ? (
        <AudioMedia src={data.audio ?? ''} cover={cover} title={title} />
      ) : (
        <ImageMedia src={cover} alt={title} />
      )}
    </Box>
  );
}
